import { Box, Button, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router';

const MedicalHealthInformationError = () => {
  const navigate = useNavigate();
  return (
    <Box sx={{ marginTop: '60px' }}>
      <Grid container direction={'row'} spacing={2}>
        <Grid item xs={0} md={3} sm={2} />
        <Grid item xs={12} md={6} sm={8}>
          <Grid container spacing={2} sx={{ textAlign: 'center', justifyContent: 'center' }}>
            <Grid item xs={11}>
              <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '20px' }}>
                問診データがありません
              </Typography>
              <Box>
                <p>問診データが追加されると</p>
                <p>こちらに表示されます</p>
              </Box>
            </Grid>
            <Grid item xs={11}>
              <Button
                onClick={() => {
                  navigate('/patient/top');
                }}
                className="bg-primary rounded py-3 text-base"
                variant="contained"
                sx={{ width: '100%' }}
                disableRipple
                disableElevation
              >
                Topへ戻る
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={0} md={3} sm={2} />
      </Grid>
    </Box>
  );
};
export default MedicalHealthInformationError;
